/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_regions_us_new_mexico4 = /** @type {(inputs: {}) => string} */ () => {
	return `Nové Mexiko`
};

const da_regions_us_new_mexico4 = /** @type {(inputs: {}) => string} */ () => {
	return `New Mexico`
};

const de_regions_us_new_mexico4 = /** @type {(inputs: {}) => string} */ () => {
	return `New Mexico`
};

const en_regions_us_new_mexico4 = /** @type {(inputs: {}) => string} */ () => {
	return `New Mexico`
};

const es_regions_us_new_mexico4 = /** @type {(inputs: {}) => string} */ () => {
	return `Nuevo México`
};

const fr_regions_us_new_mexico4 = /** @type {(inputs: {}) => string} */ () => {
	return `Nouveau-Mexique`
};

const hu_regions_us_new_mexico4 = /** @type {(inputs: {}) => string} */ () => {
	return `Új-Mexikó`
};

const it_regions_us_new_mexico4 = /** @type {(inputs: {}) => string} */ () => {
	return `Nuovo Messico`
};

const nl_regions_us_new_mexico4 = /** @type {(inputs: {}) => string} */ () => {
	return `New Mexico`
};

const pl_regions_us_new_mexico4 = /** @type {(inputs: {}) => string} */ () => {
	return `Nowy Meksyk`
};

const pt_regions_us_new_mexico4 = /** @type {(inputs: {}) => string} */ () => {
	return `Novo México`
};

const sv_regions_us_new_mexico4 = /** @type {(inputs: {}) => string} */ () => {
	return `New Mexico`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const regions_us_new_mexico4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.regions_us_new_mexico4(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("regions_us_new_mexico4", locale)
	if (locale === "cs") return cs_regions_us_new_mexico4(inputs)
	if (locale === "da") return da_regions_us_new_mexico4(inputs)
	if (locale === "de") return de_regions_us_new_mexico4(inputs)
	if (locale === "en") return en_regions_us_new_mexico4(inputs)
	if (locale === "es") return es_regions_us_new_mexico4(inputs)
	if (locale === "fr") return fr_regions_us_new_mexico4(inputs)
	if (locale === "hu") return hu_regions_us_new_mexico4(inputs)
	if (locale === "it") return it_regions_us_new_mexico4(inputs)
	if (locale === "nl") return nl_regions_us_new_mexico4(inputs)
	if (locale === "pl") return pl_regions_us_new_mexico4(inputs)
	if (locale === "pt") return pt_regions_us_new_mexico4(inputs)
	return sv_regions_us_new_mexico4(inputs)
};
export { regions_us_new_mexico4 as "regions.US.New Mexico" }